import { useState } from "react";

import { Button, Dialog, DialogActions, DialogContent, Link, Typography } from "@mui/material";

import { siteName } from "@/constants/config";

const AppFooter = () => {
  const [visible, setVisible] = useState(false);
  return (
    <div className="text-center py-[20px]">
      <Typography color="textPrimary">Safe travels from {siteName}!</Typography>
      <div className="flex flex-wrap justify-center space-x-4">
        <Link underline="hover" href="/contact">
          <Typography>Contact Us</Typography>
        </Link>
        <Link underline="hover" href="/privacy-policy">
          <Typography>Privacy Policy</Typography>
        </Link>
        <Link underline="hover" href="/terms-of-use">
          <Typography>Terms of use</Typography>
        </Link>
        <Link underline="hover" href="/faq">
          <Typography>FAQ</Typography>
        </Link>
        <Link underline="hover" href="https://awardtool.trackdesk.com/">
          <Typography>Affiliate</Typography>
        </Link>
        <Link underline="hover">
          <Typography onClick={() => setVisible(true)}>Advertiser Disclaimer</Typography>
        </Link>

        {/* <Link underline="hover" href="/">
          Join user studies
        </Link>
        <Link underline="hover" href="/">
          Feedback
        </Link>
        <Link underline="hover" href="/">
          Help Centre
        </Link> */}
      </div>

      <Dialog
        open={visible}
        onClose={() => setVisible(false)}
        PaperProps={{
          sx: {
            borderRadius: "12px",
          },
        }}
      >
        <DialogContent>
          <Typography color="primary" fontSize={18} fontWeight={600}>
            Advertiser Disclaimer
          </Typography>
          <Typography fontSize={16}>
            We may receive compensation when you click on links to credit card products and apply.
            This compensation may impact how and where products appear on this site, including, for
            example, the order in which they appear. However, this does not influence our
            evaluations and recommendations. Our editorial team conducts thorough research and
            independent assessments to provide you with the best options. We are committed to
            maintaining editorial integrity and transparency in all our content.
          </Typography>

          <Typography color="primary" fontWeight={600} fontSize={16}>
            We earn a commission when you apply for a credit card through our links, which keeps
            AwardTool humming along with free, comprehensive features. Thanks for fueling our
            caffeine addiction and keeping the lights on—we appreciate your support more than you
            know!
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setVisible(false)}>OK</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AppFooter;
